export default __webpack_public_path__ + "static/traefik-mesh-logo--white-67c9fffed7bccc1aa3e196c167224b2d.svg";